import React, { useState, useEffect } from 'react'
import { getPreExceptionTags, updateExceptionTagStatus } from '../../../services/asset.service';
import Box from '@mui/material/Box';
import { DataGrid, GridOverlay, GridToolbarContainer, GridToolbarExport } from '@mui/x-data-grid';
import CircularProgress from "@mui/material/CircularProgress";
import * as CryptoJS from "crypto-js";
import '../../ExcelUploads/AssetInfo/AssetList.css';

function getFormatedDate(dateString) {
  if (dateString != null) {
    let dte = new Date(dateString);
    let year = dte.getFullYear();
    let month = dte.getMonth() + 1;
    let day = dte.getDate();
    if (month < 10) {
      month = '0' + month;
    }
    if (day < 10) {
      day = '0' + day;
    }
    return year + '-' + month + '-' + day;
  } else {
    return null;
  }
}

const CustomLoader = () => (
  <GridOverlay>
    <CircularProgress color="primary" size={30} />
  </GridOverlay>
);

function CustomToolbar() {
  return (
    <GridToolbarContainer>
      <GridToolbarExport />
    </GridToolbarContainer>
  );
}

// Example status change handler
const handleStatusChange = (id, currentStatus) => {
  const newStatus = (currentStatus === '1') ? '0' : '1';
  // Show confirmation dialog
  if (window.confirm(`Are you sure you want to change status to ${newStatus === '1' ? 'Active' : 'Inactive'}?`)) {
    // Make API call to update status
    try {
      let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
        'param_data': { 'id': id, 'status': newStatus },
        'authToken': sessionStorage.getItem('LoggedInToken'),
      }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
      let oData = { 'token': EncryptData };
      updateExceptionTagStatus(oData).then((result) => {
        // Check response
        const response = result.data;
        if (response.data.affectedRows == 1) {
          alert('Status updated successfully!');
          window.location.reload();
        } else {
          alert('Failed to update status: ' + (response.data.message || 'Unknown error'));
        }
      })
    } catch (error) {
      console.error('Error updating status:', error);
      alert('An error occurred while updating status');
    }
  }
};

const handleFinalStatusChange = (id, finaltStatus) => {
  const newStatus = (finaltStatus === 'Finalized') ? 'Pending' : 'Finalized';
  // Show confirmation dialog
  if (window.confirm(`Are you sure you want to change status to ${finaltStatus === 'Finalized' ? 'Finalized' : 'Pending'}?`)) {
    // Make API call to update status
    try {
      let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
        'param_data': { 'id': id, 'final_status': newStatus },
        'authToken': sessionStorage.getItem('LoggedInToken'),
      }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
      let oData = { 'token': EncryptData };
      updateExceptionTagStatus(oData).then((result) => {
        // Check response
        const response = result.data;
        if (response.data.affectedRows == 1) {
          alert('Status updated successfully!');
          window.location.reload();
        } else {
          alert('Failed to update status: ' + (response.data.message || 'Unknown error'));
        }
      })
    } catch (error) {
      console.error('Error updating status:', error);
      alert('An error occurred while updating status');
    }
  }
};

function PreExceptionTags() {
  const [loading, setLoading] = useState(true);
  const [assetsDepriciation, setAssetsDepriciation] = useState([]);

  const columns = [
    {
      field: "tag", hide: false, headerName: "Tag", width: 250,
      renderCell: (params) => (
        <div className="tag-cell">
          <i className="bi bi-tag-fill"></i>
          {params.value}
        </div>
      )
    },
    {
      field: 'id',
      editable: false,
      hide: false,
      headerName: 'Action',
      width: 280,
      disableExport: true,
      renderCell: (params) => {
        if (params.row.from_module === 'Update Asset Details') {
          let encryptedTag = CryptoJS.AES.encrypt(
            JSON.stringify({ 'tag': params.row.tag }),
            process.env.REACT_APP_ENCRYPT_SECRET_KEY
          ).toString();
          return (
            <a
              className='al-btn al-btn-primary al-btn-sm'
              href={`/single-asset-capitalization?mode=edit&exception=pre&tag=${encryptedTag}`}
              style={{ margin: '4px 0' }}
            >
              <i className="bi bi-eye-fill" /> View Capitalization
            </a>
          )
        } else if (params.row.from_module === 'Finalize Disposal') {
          let encryptedTag = CryptoJS.AES.encrypt(
            JSON.stringify({ 'tag': params.row.tag }),
            process.env.REACT_APP_ENCRYPT_SECRET_KEY
          ).toString();
          return (
            <a
              className='al-btn al-btn-primary al-btn-sm'
              href={`/single-asset-capitalization?mode=edit&exception=pre&dispose=yes&tag=${encryptedTag}`}
              style={{ margin: '4px 0' }}
            >
              <i className="bi bi-eye-fill" /> View Capitalization
            </a>
          )
        } else {
          return (
            <a className='al-btn al-btn-secondary al-btn-sm' href="#" style={{ margin: '4px 0', cursor: 'not-allowed', opacity: 0.6 }}>
              <i className="bi bi-eye-slash-fill" /> View Capitalization
            </a>
          )
        }
      }
    },
    { field: "from_module", hide: false, headerName: "From Module", width: 250 },
    {
      field: "status",
      hide: false,
      headerName: "Status",
      width: 150,
      valueFormatter: (params) => (params.value === '1' || params.value === 1 ? 'Active' : 'Inactive'),
      valueGetter: (params) => (params.row.status === '1' || params.row.status === 1 ? 'Active' : 'Inactive'),
      renderCell: (params) => (
        <div
          style={{
            color: (params.row.status === '1' || params.row.status === 1) ? 'green' : 'red',
            cursor: 'pointer',
            fontWeight: 'bold'
          }}
        >
          {(params.row.status === '1' || params.row.status === 1) ? 'Active' : 'Inactive'}
        </div>
      )
    },
    { field: "created_by_name", hide: false, headerName: "Created By", width: 130 },
    {
      field: "created_at",
      hide: false,
      headerName: "Created Date",
      width: 130,
      valueFormatter: (params) => getFormatedDate(params.value),
      renderCell: (params) => (
        <p>{getFormatedDate(params.row.created_at)}</p>
      )
    },
  ];

  useEffect(() => {
    let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
      'authToken': sessionStorage.getItem('LoggedInToken'),
    }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();

    let oData = { 'token': EncryptData };

    getPreExceptionTags(oData).then((result) => {
      const data = result.data.data;
      if (data?.exceptionTags && data.exceptionTags.length > 0) {
        setAssetsDepriciation(data.exceptionTags);
      }
    })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const totalItems = assetsDepriciation.length;

  return (
    <div className="al-page" id="pre-exception-tags-page">

      {/* ══ PAGE HEADER ══ */}
      <div className="al-page-header" id="al-page-header">
        <div className="al-page-header-left">
          <div className="al-page-header-icon">
            <i className="bi bi-exclamation-triangle-fill" />
          </div>
          <div className="al-page-header-text">
            <h5 className="al-page-title">Pre Exception Tags List</h5>
            <p className="al-page-subtitle">View and manage pre-exception tagged assets</p>
          </div>
        </div>
        {!loading && assetsDepriciation.length > 0 && (
          <div className="al-record-badge" id="al-record-badge">
            <i className="bi bi-layers-fill" />
            <strong>{totalItems.toLocaleString('en-IN')}</strong>&nbsp;Total Records
          </div>
        )}
      </div>

      {/* ══ DATA GRID CARD ══ */}
      <div className="al-grid-card" id="al-grid-card">
        <div className="al-grid-card-header">
          <span className="al-grid-card-title">
            <i className="bi bi-table" /> Exception Tags Records
          </span>
          {!loading && assetsDepriciation.length > 0 && (
            <span className="al-showing-badge">
              Showing <strong>{assetsDepriciation.length}</strong> records
            </span>
          )}
        </div>

        <Box>
          <DataGrid
            rows={assetsDepriciation}
            getRowId={(row) => row.id}
            columns={columns}
            autoHeight
            className="al-data-grid"
            components={{
              LoadingOverlay: CustomLoader,
              Toolbar: CustomToolbar,
            }}
            loading={loading}
            sx={{
              border: 'none',
              fontFamily: "var(--font-body)",
              '& .MuiDataGrid-columnHeaders': {
                color: '#fff',
                fontSize: '0.75rem',
                fontWeight: 700,
                textTransform: 'uppercase',
                letterSpacing: '0.5px',
                borderBottom: 'none',
              },
              '& .MuiDataGrid-columnHeaderTitle': { color: '#000', fontSize: '0.88rem' },
              '& .MuiDataGrid-sortIcon': { color: 'rgb(46 45 45 / 85%)' },
              '& .MuiDataGrid-menuIconButton': { color: 'rgb(46 45 45 / 85%)' },
              '& .MuiDataGrid-iconButtonContainer .MuiIconButton-root': { color: 'rgba(255,255,255,0.85)' },
              '& .MuiDataGrid-row': { fontSize: '0.8rem' },
              '& .MuiDataGrid-row:hover': { backgroundColor: '#eef7fd' },
              '& .MuiDataGrid-row.Mui-selected': { backgroundColor: '#d8f0fa' },
              '& .MuiDataGrid-cell': { borderColor: '#f0f2f5' },
              '& .MuiDataGrid-footerContainer': { borderTop: '1px solid #e2e6ef', background: '#f8f9fc' },
              '& .MuiDataGrid-virtualScroller': { backgroundColor: '#fff' },
              '& .MuiDataGrid-toolbarContainer': {
                padding: '12px 16px',
                borderBottom: '1px solid #e2e6ef',
                '& .MuiButton-root': {
                  color: '#0e8aca',
                  fontWeight: 600,
                  fontSize: '0.8rem',
                  '&:hover': {
                    backgroundColor: 'rgba(14, 138, 202, 0.08)',
                  }
                }
              }
            }}
          />
        </Box>
      </div>
    </div>
  )
}

export default PreExceptionTags